export async function apiFetch<T>(input:string,init?:RequestInit):Promise<T> {
  const response=await fetch(input,{...init,credentials:'same-origin',headers:{'Content-Type':'application/json',...(init?.headers??{})}})
  if(response.status===401) window.dispatchEvent(new Event('prime-squad:unauthorized'))
  if(!response.ok){const body=await response.json().catch(()=>({})) as {error?:string};throw new Error(body.error||'Сервер временно недоступен')}
  return response.json() as Promise<T>
}

